<template>
  <div class="list-owner-car-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('listOwnerCar.page.title')" :subtitle="$t('listOwnerCar.page.subtitle')">
      <template #extra>
        <el-button v-if="activeTab === 'local' && hasPrivilege('502023032813991677')" type="primary" icon="el-icon-plus"
          @click="addOwnerCar">
          {{ $t('listOwnerCar.add') }}
        </el-button>
        <el-button v-if="activeTab === 'local'" icon="el-icon-upload2" @click="openOwnerCarImport">
          {{ $t('listOwnerCar.importCar') }}
        </el-button>
        <el-button v-if="activeTab === 'local'" icon="el-icon-download" @click="exportExcel">
          {{ $t('listOwnerCar.export') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- 页签：本系统业主车辆 / 平台月租车 -->
    <el-tabs v-model="activeTab" class="ds-tabs" @tab-click="handleTabClick">
      <el-tab-pane :label="$t('listOwnerCar.tab.local')" name="local"></el-tab-pane>
      <el-tab-pane :label="$t('listOwnerCar.tab.platform')" name="platform"></el-tab-pane>
    </el-tabs>

    <el-row :gutter="16">
      <!-- 左侧：租赁类型筛选 -->
      <el-col :xs="24" :sm="24" :md="6" :lg="5" v-if="activeTab === 'local'">
        <div class="ds-panel ds-role-tree">
          <div class="ds-role-tree__title">{{ $t('listOwnerCar.page.leaseTypeTitle') }}</div>
          <ul class="ds-role-tree__list">
            <li v-for="(item, index) in leaseTypes" :key="index" class="ds-role-tree__item"
              :class="{ 'is-active': conditions.leaseType === item.statusCd }" @click="switchLeaseType(item)">
              {{ item.name }}
            </li>
          </ul>
        </div>
      </el-col>

      <el-col :xs="24" :sm="24" :md="activeTab === 'local' ? 18 : 24" :lg="activeTab === 'local' ? 19 : 24">
        <!-- (2) SearchPanel -->
        <ds-search-panel v-if="activeTab === 'local'">
          <el-row :gutter="16">
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-input v-model.trim="conditions.carNumLike" clearable class="w-full"
                :placeholder="$t('listOwnerCar.inputCarNum')" @keyup.enter.native="queryMethod" />
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-input v-model.trim="conditions.num" clearable class="w-full"
                :placeholder="$t('listOwnerCar.inputParkingSpaceNum')" @keyup.enter.native="queryMethod" />
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-select v-model="conditions.valid" clearable class="w-full"
                :placeholder="$t('listOwnerCar.selectParkingSpaceStatus')">
                <el-option value="1" :label="$t('listOwnerCar.normal')" />
                <el-option value="3" :label="$t('listOwnerCar.expired')" />
                <el-option value="2" :label="$t('listOwnerCar.noParkingSpace')" />
              </el-select>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-input v-model.trim="conditions.ownerName" clearable class="w-full"
                :placeholder="$t('listOwnerCar.inputOwnerName')" @keyup.enter.native="queryMethod" />
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-input v-model.trim="conditions.link" clearable class="w-full"
                :placeholder="$t('listOwnerCar.inputContact')" @keyup.enter.native="queryMethod" />
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-input v-model.trim="conditions.memberCarNumLike" clearable class="w-full"
                :placeholder="$t('listOwnerCar.inputMemberCarNum')" @keyup.enter.native="queryMethod" />
            </el-col>
          </el-row>

          <template #actions>
            <el-button type="primary" icon="el-icon-search" @click="queryMethod">
              {{ $t('listOwnerCar.query') }}
            </el-button>
            <el-button icon="el-icon-refresh-left" @click="resetMethod">
              {{ $t('listOwnerCar.reset') }}
            </el-button>
          </template>
        </ds-search-panel>

        <!-- 平台月租车查询条件：车牌号由平台接口过滤，其余条件在当前页前端过滤 -->
        <ds-search-panel v-else>
          <el-row :gutter="16">
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-input v-model.trim="platformConditions.plateNumber" clearable class="w-full"
                :placeholder="$t('listOwnerCar.inputCarNum')" @keyup.enter.native="queryPlatformMethod" />
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-input v-model.trim="platformConditions.num" clearable class="w-full"
                :placeholder="$t('listOwnerCar.inputParkingSpaceNum')" @keyup.enter.native="queryPlatformMethod" />
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-input v-model.trim="platformConditions.ownerName" clearable class="w-full"
                :placeholder="$t('listOwnerCar.inputOwnerName')" @keyup.enter.native="queryPlatformMethod" />
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-input v-model.trim="platformConditions.link" clearable class="w-full"
                :placeholder="$t('listOwnerCar.inputContact')" @keyup.enter.native="queryPlatformMethod" />
            </el-col>
          </el-row>

          <template #actions>
            <el-button type="primary" icon="el-icon-search" @click="queryPlatformMethod">
              {{ $t('listOwnerCar.query') }}
            </el-button>
            <el-button icon="el-icon-refresh-left" @click="resetPlatformMethod">
              {{ $t('listOwnerCar.reset') }}
            </el-button>
          </template>
        </ds-search-panel>

        <!-- (3)(4)(6) Toolbar + DataTable + PaginationBar -->
        <div class="ds-panel" v-if="activeTab === 'local'">
          <ds-toolbar :total="total" :density="density" :show-column-setting="false"
            :show-refresh="true" @update:density="density = $event" @refresh="listOwnerCarData">
            <template #left>
              <span class="ds-panel__title">{{ $t('listOwnerCar.carInfo') }}</span>
            </template>
          </ds-toolbar>

          <ds-data-table :data="ownerCars" :loading="loading" :error="hasError" :error-message="errorMessage"
            :density="density" border :empty-description="$t('listOwnerCar.page.empty')" @retry="listOwnerCarData">
            <el-table-column prop="carNum" :label="$t('listOwnerCar.carNum')" align="center" min-width="120">
              <template slot-scope="scope">
                <router-link :to="`/views/car/carDetail?memberId=${scope.row.memberId}`" target="_blank">
                  <span class="ds-num">{{ scope.row.carNum || '-' }}</span>
                </router-link>
              </template>
            </el-table-column>
            <el-table-column prop="memberCarCount" :label="$t('listOwnerCar.memberCar')" align="center" width="100">
              <template slot-scope="scope">
                <el-link type="primary" @click="toCarMember(scope.row)">
                  <span class="ds-num">{{ scope.row.memberCarCount || 0 }}</span>
                </el-link>
              </template>
            </el-table-column>
            <el-table-column prop="roomName" :label="$t('listOwnerCar.roomNum')" align="center" width="150" />
            <el-table-column :label="$t('listOwnerCar.carPlateType')" align="center" width="110">
              <template slot-scope="scope">
                <ds-status-tag size="sm" :type="scope.row.leaseType === 'T' ? 'warning' : 'primary'"
                  :label="scope.row.leaseType === 'T' ? $t('listOwnerCar.temporaryCar') : (scope.row.leaseTypeName || '-')" />
              </template>
            </el-table-column>
            <el-table-column prop="carTypeName" :label="$t('listOwnerCar.carType')" align="center" width="110" />
            <el-table-column prop="carColor" :label="$t('listOwnerCar.color')" align="center" width="90" />
            <el-table-column :label="$t('listOwnerCar.owner')" align="center" min-width="150">
              <template slot-scope="scope">
                <router-link :to="`/views/owner/ownerDetail?ownerId=${scope.row.ownerId}`" target="_blank">
                  {{ scope.row.ownerName || '-' }}({{ scope.row.link }})
                </router-link>
              </template>
            </el-table-column>
            <el-table-column :label="$t('listOwnerCar.parkingSpace')" align="center" width="140">
              <template slot-scope="scope">
                <span v-if="scope.row.areaNum && scope.row.state === '1001'">
                  {{ scope.row.areaNum }}-{{ scope.row.num }}
                </span>
                <span v-else>{{ $t('listOwnerCar.parkingSpaceReleased') }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('listOwnerCar.validity')" align="center" width="170">
              <template slot-scope="scope">
                <div v-if="scope.row.leaseType === 'H' || scope.row.leaseType === 'S'">
                  <span class="ds-num">{{ scope.row.startTime || '-' }}</span><br>
                  <span class="ds-num">{{ scope.row.endTime || '-' }}</span>
                </div>
                <div v-else>--</div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('listOwnerCar.status')" align="center" width="130">
              <template slot-scope="scope">
                <ds-status-tag size="sm" :type="resolveCarState(scope.row).type"
                  :label="resolveCarState(scope.row).label" />
                <div v-if="scope.row.iotStateName" class="ds-cell-sub">
                  <el-link type="primary" @click="viewIotStateRemark(scope.row)">{{ scope.row.iotStateName }}</el-link>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="remark" :label="$t('listOwnerCar.remark')" align="center" min-width="120"
              show-overflow-tooltip />
            <el-table-column :label="$t('listOwnerCar.operation')" align="center" width="360" fixed="right">
              <template slot-scope="scope">
                <el-button v-if="scope.row.state !== '3003' && hasPrivilege('502023032855861676')" size="mini"
                  @click="deleteCarParkingSpace(scope.row)">
                  {{ $t('listOwnerCar.release') }}
                </el-button>
                <el-button v-else-if="hasPrivilege('502023032809021678')" size="mini"
                  @click="addCarParkingSpace(scope.row)">
                  {{ $t('listOwnerCar.renew') }}
                </el-button>
                <el-button v-if="scope.row.leaseType === 'H'" size="mini" @click="toBuyCarMonthCard(scope.row)">
                  {{ $t('listOwnerCar.buyMonthlyCard') }}
                </el-button>
                <el-button v-if="scope.row.carTypeCd !== '1003' && hasPrivilege('502023032804261679')" size="mini"
                  @click="openEditOwnerCar(scope.row)">
                  {{ $t('listOwnerCar.modify') }}
                </el-button>
                <el-button size="mini" type="primary" @click="openChangeOwnerDialog(scope.row)">
                  {{ $t('listOwnerCar.changeOwner') }}
                </el-button>
                <el-button v-if="hasPrivilege('502023032822121680')" size="mini" type="danger"
                  @click="openDelOwnerCarModel(scope.row)">
                  {{ $t('listOwnerCar.delete') }}
                </el-button>
              </template>
            </el-table-column>
          </ds-data-table>

          <ds-pagination-bar :total="total" :page="currentPage" :size="pageSize" :page-sizes="[10, 20, 30, 50]"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>

        <!-- 平台月租车列表 -->
        <div class="ds-panel" v-else>
          <ds-toolbar :total="platformTotal" :density="density" :show-column-setting="false"
            :show-refresh="true" @update:density="density = $event" @refresh="listPlatformData">
            <template #left>
              <span class="ds-panel__title">{{ $t('listOwnerCar.platformCarInfo') }}</span>
            </template>
          </ds-toolbar>

          <ds-data-table :data="filteredPlatformRents" :loading="platformLoading" :error="platformHasError"
            :error-message="platformErrorMessage" :density="density" border
            :empty-description="$t('listOwnerCar.page.platformEmpty')" @retry="listPlatformData">
            <el-table-column prop="carNum" :label="$t('listOwnerCar.carNum')" align="center" min-width="120">
              <template slot-scope="scope">
                <span class="ds-num">{{ scope.row.carNum || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="ownerName" :label="$t('listOwnerCar.owner')" align="center" min-width="140">
              <template slot-scope="scope">
                {{ scope.row.ownerName || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="empMobile" :label="$t('listOwnerCar.phoneNumber')" align="center" width="130">
              <template slot-scope="scope">
                {{ scope.row.empMobile || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="roomName" :label="$t('listOwnerCar.platformRoomAddress')" align="center" min-width="150"
              show-overflow-tooltip />
            <el-table-column prop="num" :label="$t('listOwnerCar.platformParkingSpace')" align="center" width="120">
              <template slot-scope="scope">
                {{ scope.row.num || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="leaseTypeName" :label="$t('listOwnerCar.platformLeaseType')" align="center" width="110">
              <template slot-scope="scope">
                <ds-status-tag size="sm" type="primary" :label="scope.row.leaseTypeName || '-'" />
              </template>
            </el-table-column>
            <el-table-column :label="$t('listOwnerCar.validity')" align="center" width="180">
              <template slot-scope="scope">
                <span class="ds-num">{{ scope.row.startTime || '-' }}</span><br>
                <span class="ds-num">{{ scope.row.endTime || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('listOwnerCar.status')" align="center" width="110">
              <template slot-scope="scope">
                <ds-status-tag size="sm" :type="resolvePlatformState(scope.row).type"
                  :label="resolvePlatformState(scope.row).label" />
              </template>
            </el-table-column>
          </ds-data-table>

          <ds-pagination-bar :total="platformTotal" :page="platformPage" :size="platformPageSize"
            :page-sizes="[10, 20, 30, 50]" @size-change="handlePlatformSizeChange"
            @current-change="handlePlatformCurrentChange" />
        </div>
      </el-col>
    </el-row>

    <import-owner-car ref="importOwnerCar" @success="listOwnerCarData" />
    <edit-car ref="editCar" @success="listOwnerCarData" />
    <delete-owner-car ref="deleteOwnerCar" @success="listOwnerCarData" />
    <change-owner-dialog ref="changeOwnerDialog" @success="listOwnerCarData" />
  </div>
</template>

<script>
import { queryOwnerCars, exportData, deleteCarParkingSpace } from '@/api/car/listOwnerCarApi'
import { listMonthlyRents } from '@/api/car/parkingMonthlyRentApi'
import ImportOwnerCar from '@/components/car/importOwnerCar'
import EditCar from '@/components/car/editCar'
import DeleteOwnerCar from '@/components/car/deleteOwnerCar'
import ChangeOwnerDialog from '@/components/car/changeOwnerDialog'
import { getDict } from '@/api/community/communityApi'
import { getCommunityId } from '@/api/community/communityApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsSearchPanel from '@/components/ds/ds-search-panel.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsPaginationBar from '@/components/ds/ds-pagination-bar.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'ListOwnerCar',
  components: {
    ImportOwnerCar,
    EditCar,
    DeleteOwnerCar,
    ChangeOwnerDialog,
    DsPageHeader,
    DsSearchPanel,
    DsToolbar,
    DsDataTable,
    DsPaginationBar,
    DsStatusTag
  },
  data() {
    return {
      loading: false,
      hasError: false,
      errorMessage: '',
      density: 'default',
      ownerCars: [],
      leaseTypes: [],
      conditions: {
        carNumLike: '',
        num: '',
        valid: '',
        leaseType: 'H',
        ownerName: '',
        link: '',
        memberCarNumLike: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      communityId: '',
      // 页签：local = 本系统业主车辆，platform = 平台月租车
      activeTab: 'local',
      // 平台月租车列表状态
      platformLoading: false,
      platformHasError: false,
      platformErrorMessage: '',
      platformRents: [],
      platformTotal: 0,
      platformPage: 1,
      platformPageSize: 10,
      platformConditions: {
        plateNumber: '',
        num: '',
        ownerName: '',
        link: ''
      }
    }
  },
  computed: {
    /**
     * 平台月租车当前页的前端过滤结果
     *
     * 平台接口只支持按车牌号过滤，车位编号、车主姓名、联系方式只能在前端对当前页记录过滤，
     * 因此过滤后条数可能少于每页条数。
     */
    filteredPlatformRents() {
      const { num, ownerName, link } = this.platformConditions
      return this.platformRents.filter(row => {
        if (num && !this.matchText(row.num, num)) {
          return false
        }
        if (ownerName && !this.matchText(row.ownerName, ownerName)) {
          return false
        }
        if (link && !this.matchText(row.empMobile, link)) {
          return false
        }
        return true
      })
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.initData()
    this.listOwnerCarData()
  },
  methods: {
    async initData() {
      try {
        const leaseTypes = await getDict('owner_car', 'lease_type')
        this.leaseTypes = [{ statusCd: '', name: this.$t('listOwnerCar.allCars') }, ...leaseTypes,
        { statusCd: 'expireCar', name: this.$t('listOwnerCar.expiredCars') }]
      } catch (error) {
        console.error('获取租赁类型失败:', error)
      }
    },

    async listOwnerCarData() {
      this.loading = true
      this.hasError = false
      try {
        const params = {
          ...this.conditions,
          page: this.currentPage,
          row: this.pageSize,
          communityId: this.communityId,
          // 本页签去掉与平台月租车重复的记录，只在本页签生效
          excludePlatformCar: 'Y'
        }

        if (this.conditions.leaseType === 'expireCar') {
          params.leaseType = ''
          params.valid = 3
        }

        const response = await queryOwnerCars(params)
        this.ownerCars = response.data
        this.total = response.total
      } catch (error) {
        console.error('获取车辆列表失败:', error)
        this.hasError = true
        this.errorMessage = this.$t('listOwnerCar.fetchError')
        this.$message.error(this.$t('listOwnerCar.fetchError'))
      } finally {
        this.loading = false
      }
    },

    async listPlatformData() {
      this.platformLoading = true
      this.platformHasError = false
      try {
        const response = await listMonthlyRents({
          page: this.platformPage,
          row: this.platformPageSize,
          plateNumber: this.platformConditions.plateNumber
        })
        this.platformRents = response.data || []
        this.platformTotal = response.total || 0
      } catch (error) {
        console.error('获取平台月租车列表失败:', error)
        this.platformRents = []
        this.platformTotal = 0
        this.platformHasError = true
        this.platformErrorMessage = this.$t('listOwnerCar.fetchError')
        this.$message.error(this.$t('listOwnerCar.fetchError'))
      } finally {
        this.platformLoading = false
      }
    },

    handleTabClick() {
      if (this.activeTab === 'platform') {
        this.listPlatformData()
      }
    },

    switchLeaseType(item) {
      this.conditions.leaseType = item.statusCd
      this.currentPage = 1
      this.listOwnerCarData()
    },

    queryMethod() {
      this.currentPage = 1
      this.listOwnerCarData()
    },

    resetMethod() {
      this.conditions = {
        carNumLike: '',
        num: '',
        valid: '',
        leaseType: 'H',
        ownerName: '',
        link: '',
        memberCarNumLike: ''
      }
      this.currentPage = 1
      this.listOwnerCarData()
    },

    queryPlatformMethod() {
      this.platformPage = 1
      this.listPlatformData()
    },

    resetPlatformMethod() {
      this.platformConditions = {
        plateNumber: '',
        num: '',
        ownerName: '',
        link: ''
      }
      this.platformPage = 1
      this.listPlatformData()
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.listOwnerCarData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.listOwnerCarData()
    },

    handlePlatformSizeChange(val) {
      this.platformPageSize = val
      this.platformPage = 1
      this.listPlatformData()
    },
    handlePlatformCurrentChange(val) {
      this.platformPage = val
      this.listPlatformData()
    },

    addOwnerCar() {
      this.$router.push('/views/car/hireParkingSpace')
    },

    openEditOwnerCar(car) {
      this.$refs.editCar.open(car)
    },

    openDelOwnerCarModel(car) {
      this.$refs.deleteOwnerCar.open(car)
    },

    deleteCarParkingSpace(car) {
      this.$confirm(this.$t('listOwnerCar.confirmRelease'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(async () => {
        try {
          await deleteCarParkingSpace(car)
          this.$message.success(this.$t('common.operationSuccess'))
          this.listOwnerCarData()
        } catch (error) {
          console.error('释放车位失败:', error)
          this.$message.error(error.message || this.$t('listOwnerCar.releaseError'))
        }
      })
    },

    addCarParkingSpace(car) {
      this.$router.push(`/views/car/carAddParkingSpace?carId=${car.carId}`)
    },

    toBuyCarMonthCard(car) {
      this.$router.push(`/views/fee/buyCarMonthCard?carNum=${car.carNum}`)
    },

    toCarMember(car) {
      this.$router.push(`/views/car/carDetail?memberId=${car.carId}&tab=carDetailMember`)
    },

    openChangeOwnerDialog(car) {
      this.$refs.changeOwnerDialog.open(car)
    },

    resolveCarState(car) {
      if (car.state === '3003') {
        return { type: 'danger', label: this.$t('listOwnerCar.expired') }
      }
      const endTime = new Date(car.endTime)
      if (endTime > new Date()) {
        return { type: 'success', label: this.$t('listOwnerCar.normal') }
      }
      return { type: 'danger', label: this.$t('listOwnerCar.expired') }
    },

    /**
     * 平台月租车状态：按到期时间判断是否还在有效期内
     */
    resolvePlatformState(car) {
      if (!car.endTime) {
        return { type: 'info', label: this.$t('listOwnerCar.platformUnknown') }
      }
      const endTime = new Date(car.endTime.replace(/\.\d+$/, ''))
      if (endTime > new Date()) {
        return { type: 'success', label: this.$t('listOwnerCar.normal') }
      }
      return { type: 'danger', label: this.$t('listOwnerCar.expired') }
    },

    /**
     * 前端模糊匹配，平台记录里字段可能为空
     */
    matchText(value, keyword) {
      if (!value) {
        return false
      }
      return String(value).toLowerCase().includes(String(keyword).toLowerCase())
    },

    openOwnerCarImport() {
      this.$refs.importOwnerCar.open()
    },

    async exportExcel() {
      try {
        const params = {
          ...this.conditions,
          communityId: this.communityId,
          pagePath: 'exportOwnerCar'
        }
        await exportData(params)
        this.$message.success(this.$t('common.operationSuccess'))
        this.$router.push('/pages/property/downloadTempFile?tab=下载中心')
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error(error.message || this.$t('listOwnerCar.exportError'))
      }
    },

    viewIotStateRemark(car) {
      this.$alert(car.iotRemark, `${car.carNum} ${this.$t('listOwnerCar.iotSyncDetail')}`, {
        confirmButtonText: this.$t('common.confirm')
      })
    },

  }
}
</script>

<style lang="scss" scoped>
.list-owner-car-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

.ds-tabs {
  margin-bottom: var(--ds-spacing-md);

  ::v-deep .el-tabs__header {
    margin-bottom: 0;
  }
}

.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}

.ds-role-tree {
  padding: var(--ds-spacing-md) 0;

  &__title {
    padding: 0 var(--ds-spacing-lg) var(--ds-spacing-sm);
    font-size: var(--ds-font-size-sm);
    font-weight: 600;
    color: var(--ds-gray-600);
  }

  &__list {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  &__item {
    padding: 10px var(--ds-spacing-lg);
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-700);
    text-align: center;
    cursor: pointer;
    border-left: 3px solid transparent;
    transition: background-color var(--ds-transition-fast), color var(--ds-transition-fast);

    &:hover {
      background-color: var(--ds-gray-100);
    }

    &.is-active {
      background-color: var(--ds-primary-sub);
      border-left-color: var(--ds-primary);
      color: var(--ds-primary);
      font-weight: 600;
    }
  }
}
</style>
